'use strict';

import * as dialog from '../components/dialog';
import {getProductContainer, getPidValue} from './productUtils';
import modules from '../helpers/modules';
import {subscribe} from '../helpers/pubSub';
import {getQueryStringParams, appendParamsToURL} from '../helpers/urlUtilities';
import '../components/jquery.zoom.min';
import * as mypichzoom from '../components/pinchzoom';

function _onZoomSlideChange(contextEl) {
    subscribe('productZoom:slideChange', function() {
        modules.tracking.init(null, {
            trackEvent: 'productSwitchImage',
            trackObject: {
                asyncParams: {
                    pid: getPidValue(contextEl)
                }
            }
        });
    });
}

/**
 * Grab the configuration from the closest product container's data-product-querystring attribute.
 * Then display a modal using these configs.
 * @return {[type]} [description]
 */
export function handleZoomTrigger() {
    let productContainer = getProductContainer(this),
        params = getQueryStringParams(productContainer.getAttribute('data-product-querystring')),
        // $mainSlider = $(this.closest('[data-product-component="image-gallery"]')),
        selectedIndex = this.querySelector('[data-product-component="image"]').getAttribute('data-image-index');

    params.startindex = selectedIndex;
    //Always set PID in the case the value is missing from the params.
    params.pid = getPidValue(this);

    dialog.open({
        url: appendParamsToURL(window.SFRA.Urls.productZoom, params),
        options: {
            modalID: 'productZoom',
            modalClass: 'modal--product-zoom modal--small-full',
            keepAlive: false,
            afterScrollLockCallback: function(modal) {
                let zoomGAllery = modal.querySelector('[data-product-component="image-gallery"]'),
                    productzoomitem = document.querySelectorAll('[data-zoom-item="data-zoom"]');

                //Force browser to wait until the previous instruction is done before continuing.
                //This ensures the zoom gallery is properly adjusted after the scrollbars are hidden.
                window.setTimeout(function() {
                    $(zoomGAllery).slick('setPosition');
                    //pinch zoom for devices.
                    if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
                        Array.from(document.querySelectorAll('div.pinch-zoom img')).forEach((element) => {
                            new mypichzoom.default(element, {});
                        });
                    } else {
                        $(productzoomitem).zoom({on: 'grab' });
                    }
                }, 0);
            }
        }
    });
}

export function setupZoomTriggers() {
    let zoomTriggers = document.querySelectorAll('[data-product-component="zoom-trigger"]');

    _onZoomSlideChange(zoomTriggers[0]);

    [].forEach.call(zoomTriggers, function(currentTrigger) {
        $(currentTrigger).attr('tabindex', '0');
        currentTrigger.addEventListener('click', handleZoomTrigger);
    });
}
